var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2.73828C8.36819 2.73828 8.66667 3.03676 8.66667 3.40495V8.07161H13.3333C13.7015 8.07161 14 8.37009 14 8.73828C14 9.10647 13.7015 9.40495 13.3333 9.40495H8.66667V14.0716C8.66667 14.4398 8.36819 14.7383 8 14.7383C7.63181 14.7383 7.33333 14.4398 7.33333 14.0716V9.40495H2.66667C2.29848 9.40495 2 9.10647 2 8.73828C2 8.37009 2.29848 8.07161 2.66667 8.07161H7.33333V3.40495C7.33333 3.03676 7.63181 2.73828 8 2.73828Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/AddIcon.c74fde19b8568230173c61ba543bac84.svg";
export { ForwardRef as ReactComponent };